__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-10-05-1791203403-stable-dev/";